import { useBoolean } from '@dreryk/react-common';

import { PreInterviewUpdateModal } from './PreInterviewUpdateModal';

type PreInterviewUpdateModalOpenerRenderProps = { openModal: VoidFunction };
type PreInterviewUpdateModalOpenerProps = {
   readonly appointmentId: number;
   readonly beginDate: Date;
   readonly endDate: Date;
   readonly patientFullName: string;
   readonly surveyId: number;
   readonly children: (renderProps: PreInterviewUpdateModalOpenerRenderProps) => JSX.Element;
};

export const PreInterviewUpdateModalOpener = (props: PreInterviewUpdateModalOpenerProps): JSX.Element => {
   const [{ setFalse: closeModal, setTrue: openModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}

         {modalOpened ? (
            <PreInterviewUpdateModal
               appointmentId={props.appointmentId}
               beginDate={props.beginDate}
               endDate={props.endDate}
               patientFullName={props.patientFullName}
               surveyId={props.surveyId}
               onClose={closeModal}
            />
         ) : null}
      </>
   );
};
